import { createTheme } from '@mui/material/styles';
import { Theme as SystemTheme } from '@mui/system';

export const Black = '#252e2a'
export const BrightBlue = '#0086bf'
export const Cobalt = '#004c97'
export const Grey5 = '#404040'
export const Grey4 = '#09101d'
export const Grey3 = '#898d8d'
export const Grey2 = '#c7c8c6'
export const Grey1 = '#efeff0'
export const Indigo = '#071d49'
export const OffWhite = '#f9f9f9'
export const Orange = '#Ed8800'
export const SkyBlue = '#c2ecf7'
export const MintGreen = '#8fd7c2'

export const Colors = {
    Black,
    BrightBlue,
    Cobalt,
    Grey1,
    Grey2,
    Grey3,
    Grey4,
    Grey5,
    Indigo,
    MintGreen,
    OffWhite,
    Orange,
    SkyBlue
}

//https://mui.com/customization/theming/#theme-builder
const theme : SystemTheme = createTheme({
  palette: {
    primary: {
      main: Colors.Grey5,
      light: Colors.Grey4,
      dark: Colors.Black,
      contrastText: Colors.OffWhite
    },
    secondary: {
      main: Colors.Orange,
      light: '#fe9c11',
      dark: '#ff5722',
      contrastText: Colors.OffWhite
    },
    info: {
      main: Colors.MintGreen,
      contrastText: Colors.OffWhite
    }
  },
})

export default theme